module.exports = __webpack_public_path__ + "img/CREDIT_CARD.cc191fc3.svg";